import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';

const FIELDS = {
    workExperienceIn: {
        type: "multiselect",
        label: "Work Experience",
        isRequired: true
    },
    workLocations: {
        type: "multiselect",
        label: "Work Locations",
        isRequired: true
    },
    balanceCapacity: {
        type: "input",
        label: "Balance Capacity (INR)",
        isRequired: false,
        validations: {
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.ONLY_NUMBER
            }
        }
    },
    turnover: {
        type: "input",
        label: "Turnover (INR)",
        isRequired: false,
        validations: {
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.ONLY_NUMBER
            }
        }
    },
    experience: {
        type: "input",
        label: "Experience (In Years)",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.ONLY_NUMBER
            }
        }
    },
    generalType: {
        type: "select",
        label: "General Type",
        isRequired: true,
        options: [{ id: "L", name: "L" }, { id: "L+M", name: "L+M" }],
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    additionalInfo: {
        type: "input",
        isMultiline: true,
        label: "About Company",
        isRequired: true,
        rows : 4,
        isMultiline:  true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2,
                maximum: 1000
            }
        }
    }
};

export default FIELDS;